var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 5.75 5.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: -1,
    y: 4,
    rx: 1,
    transform: "rotate(45 5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.329.758 8.042 8.044A1.001 1.001 0 0 0 9.456 9.46l7.287-7.287A1 1 0 0 0 15.329.758z"
  }))));
};

export default SvgArrowLeft;